<template>
  <el-card class="h-full">
    <div class="w-full h-full flex flex-col" v-if="currentComp === 'TABLE'">
      <div class="flex mb-10px flex-wrap">
        <el-input
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="试卷名称/编码"
          maxlength="50"
          v-model="searchData.keywords"
          clearable
        ></el-input>
        <el-select
          v-model="searchData.paperCategory"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="试卷分类"
          clearable
        >
          <el-option
            v-for="item in pagerTypeList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-button class="mb-10px" size="small" type="primary" @click="handleSearch()"
          >搜索</el-button
        >
        <el-button class="mb-10px" size="small" @click="resetText()">重置</el-button>
        <el-button
          class="mb-10px"
          size="small"
          type="primary"
          @click="handleEvent(null, 'create')"
          :disabled="!$hasAccess('create')"
          >新增</el-button
        >
        <el-button
          class="mb-10px"
          size="small"
          type="danger"
          @click="handleEvent(null, 'batchDelete')"
          :disabled="!$hasAccess('delete')"
          >批量删除</el-button
        >
      </div>
      <div class="flex-auto h-0px">
        <el-table
          :data="equipDataList"
          border
          class="w-full"
          :height="tableHeight"
          stripe
          v-loading="equipTableLoading"
          @selection-change="handleSelectionEquip"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            label="试卷编码"
            prop="paperCode"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="试卷名称" prop="paperName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="试卷分类" prop="paperCategoryStr" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="试卷总分" prop="totalScore" width="180" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="创建时间" prop="creationTime" width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.creationTime &&
                  dayjs(scope.row.creationTime).format('YYYY-MM-DD HH:mm:ss')
              }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="描述" prop="examType" show-overflow-tooltip> </el-table-column> -->
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="equipTableSizeChange"
          @current-change="equipTableCurrentChange"
          :current-page.sync="equipPageConfig.SkipCount"
          :page-size.sync="equipPageConfig.MaxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="equipTotalCount"
          class="float-right mt-20px ml-10px"
        ></el-pagination>
      </div>
    </div>

    <paper-form
      v-if="['CREATE', 'UPDATE', 'READ'].includes(currentComp)"
      :pageType="pageType"
      :rowId="rowId"
      @refreshList="refreshList"
      @cancel="checkComp('TABLE')"
    ></paper-form>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import { ExamPaperApi } from '@wiz-api/exam-management'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import utils from '@/components/safety/enumField/utils'
import PaperForm from '../../components/examManage/PaperForm'

const examPaperApi = new ExamPaperApi()

export default {
  name: 'paper-manage',
  components: {
    PaperForm,
    TableOperateButton,
  },
  data() {
    return {
      // 行id
      rowId: undefined,
      pageType: 'create',
      currentComp: 'TABLE',
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      searchData: {
        topic: '',
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionEquipData: [],
      pagerTypeList: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '编辑',
            click: () => {
              return this.handleEvent(val, 'update')
            },
            isShow: this.$hasAccess('update') && !val.isCorrelationPlan,
          },
          {
            text: '删除',
            click: () => {
              return this.handleEvent(val, 'delete')
            },
            isShow: this.$hasAccess('delete') && !val.isCorrelationPlan,
          },
        ]
      }
    },
  },
  methods: {
    // 刷新接口
    refreshList() {
      this.checkComp('TABLE')
      this.handleSearch()
    },
    // 切换组件
    checkComp(name) {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = name
      })
    },
    // 重置
    resetText() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    // 列表操作-事件 设备设施清单
    async handleEvent(row = null, operation) {
      let err = null
      let res = null
      switch (operation) {
        case 'create':
          this.initDialog(operation)
          break
        case 'delete':
          this.$confirm('是否删除该记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await examPaperApi.callDelete(row.id)
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        case 'read':
          this.rowId = row.id
          this.initDialog(operation)
          break
        case 'update':
          this.rowId = row.id
          this.initDialog(operation)
          break
        // 批量删除
        case 'batchDelete':
          if (this.selectionEquipData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选要删除的记录',
              type: 'warning',
            })
            return
          }
          const canDelete = this.selectionEquipData.some((item) => {
            return item.isCorrelationPlan
          })

          if (canDelete) {
            this.$message({
              showClose: true,
              message: '勾选的设备存在评价为是的记录，无法删除',
              type: 'warning',
            })
            return
          }
          this.$confirm('是否批量删除勾选的记录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await examPaperApi.deleteMany({
                ids: _.map(this.selectionEquipData, (item) => {
                  return item.id
                }),
              })
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        default:
          break
      }
    },
    // 弹窗初始化操作
    initDialog(operation) {
      this.checkComp(operation.toUpperCase())
      this.pageType = operation
    },
    handleSelectionEquip(values) {
      this.selectionEquipData = values
    },
    // 搜索
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      this.selectionEquipData = []
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...searchData,
      }
      this.equipTableLoading = true
      const [err, res] = await examPaperApi.pagedListQuery(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
  mounted() {
    utils.getDataCategory(
      ['ExamManagement.DataCategory.ExamPapersClassification'],
      ['pagerTypeList'],
      this
    )
    this.getEquipList()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
